import React, { Component } from "react";
import cx from "classnames";
import { addonTypes, addonDefaultProps } from "../../types";
import { RawHTML } from "../common";
import styles from "./styles.less";

class AddonCarousel extends Component {
  onIncrement = e => {
    const { name, titles, id, onIncrement } = this.props;
    const msg = `${titles.Addon} ${name} ${titles.WasAddedToReservation}`;
    e.preventDefault();
    onIncrement(id, msg);
  };

  onShowAddonDetailsClick = e => {
    const { id, onShowAddonDetailsClick } = this.props;
    e.stopPropagation();
    onShowAddonDetailsClick(id);
  };

  render() {
    const {
      name,
      description,
      imageURL,
      price,
      isRtl,
      titles,
      isMobileView
      //defaultImageURL
    } = this.props;
    return (
      <div
        className={cx(styles.addon, {
          [styles.mobileView]: isMobileView
        })}
        onClick={this.onIncrement}
        onKeyDown={this.onIncrement}
        role="button"
        tabIndex="0"
      >
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            src={imageURL}
            alt={`${name} ${description}`}
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={cx(styles.name, { [styles.rtl]: isRtl })}>
            <RawHTML className={styles.title} html={name} />
            <div
              className={styles.addonDescriptionReadMoreText}
              onClick={this.onShowAddonDetailsClick}
              onKeyDown={this.onShowAddonDetailsClick}
              role="button"
              tabIndex="0"
            >
              {titles.ReadMore}
            </div>
          </div>
          <div className={styles.buttonsWrapper}>
            <div className={styles.priceWrapper}>{price}</div>
            <div className={cx(styles.btn, styles.plus)} />
          </div>
        </div>
      </div>
    );
  }
}

AddonCarousel.defaultProps = addonDefaultProps;

AddonCarousel.propTypes = addonTypes;

export default AddonCarousel;



// WEBPACK FOOTER //
// ./src/components/AddonCarousel/AddonCarousel.js